var __rspack_ns_object = JSON.parse('{"Export":"Exportar","Create Report":"Criar relatório"}')